import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {ApiService} from '@shared/services';
import {IApi} from '@entities/api';
import {ESubjectType, IListSubject} from '@entities/subject';

@Injectable({
  providedIn: 'root',
})
export class HistoryApi extends ApiService {
  public getHistory(): Observable<IApi<IListSubject[]>> {
    return this.get<IApi<IListSubject[]>>(`${this.apiUrl}/history`).pipe(
      map(this.mapApiSubjects.bind(this))
    );
  }

  public saveToHistory(subjectId: number): Observable<IApi<IListSubject>> {
    return this.post<IApi<IListSubject>>(`${this.apiUrl}/history`, {
      subjectId,
    }).pipe(map(this.mapApiSubjects.bind(this)));
  }

  private mapSubject(subject: IListSubject): IListSubject {
    return {
      ...subject,
      type: subject.code ? ESubjectType.Juridical : ESubjectType.Physical,
    };
  }

  private mapApiSubjects<T extends IListSubject | IListSubject[]>(
    data: IApi<T>
  ): IApi<T> {
    if (Array.isArray(data.data)) {
      return {
        data: data.data.map((product) => this.mapSubject(product)) as T,
        meta: data.meta,
      };
    }

    return {
      data: this.mapSubject(data.data) as T,
    };
  }
}
